import { getProjectFromGraph } from '../core/utils/utils';
import Tooltip from '@material-ui/core/Tooltip';
import { APPLICATION_PATHS } from '../application-core/constants';
import LabelIcon from '@material-ui/icons/Label';
import withGS from '../core/withGShoc';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import GS from '../grafsync/grafsync';
import { globalStyles } from './style/gstheme';
import VocabularyManagerIcon from './icons/VocabularyManager';

const styles = theme => {
    return Object.assign({
        link: {
            color: 'white',
            marginRight: 10,
            marginBottom: 10,
            maxWidth: '100%',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }, globalStyles);
};

class OtherProjectLink extends React.Component {

    handleDeleteLink() {
        // We do this directly to ensure direction of link delete is correct 
        GS.deleteProperty(this.props.source, this.props.sourceGraph, this.props.property, this.props.id, null, null, this.props.propertyGraph);
    }

    buildLink = () => {
        const data = this.props.data;
        const inScheme = data.inScheme && data.inScheme.length > 0 ? "&taxonomy=" + data.inScheme[0] : "";
        const resource = inScheme !== "" ?
            data.prefLabel ?
                "&view=concept&concept=" + data.id
                :
                "&view=label&label=" + data.id
            :
            "";
        const project = getProjectFromGraph(this.props.graph);
        const page = inScheme !== "" ? "taxonomy" : "detail";
        let link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/' + page + '#project='
            + project + inScheme + resource;
        return link;
    }

    handleClick = () => {
        const link = this.buildLink();
        this.props.history.push(link);
    }

    render() {

        const { classes, isReadOnly, id, dataTest, source, data, defaultLang, viewLang, graph } = this.props;
        const notAvailable = data._notAvailable;
        const label = data.prefLabel ?
            data.prefLabel[viewLang] ?
                data.prefLabel[viewLang]
                :
                data.prefLabel[defaultLang] || id
            :
            data.title ?
                data.title[viewLang] ?
                    data.title[viewLang]
                    :
                    data.title[defaultLang] || id
                :
                data.literalForm ?
                    data.literalForm[viewLang] ?
                        data.literalForm[viewLang]
                        :
                        data.literalForm[defaultLang] || id
                    :
                    id;
        const project = getProjectFromGraph(this.props.graph);
        const projectData = GS.isLoaded(project, graph) ? GS.data(project, graph) : {};
        const projectTitle = projectData.title ?
            projectData.title[viewLang] ?
                projectData.title[viewLang]
                :
                projectData.title[defaultLang] || projectData.id
            :
            id;

        return (
            <Tooltip title={<span>
                <span style={{ display: 'block', marginTop: 4, marginBottom: 4 }}>
                    <VocabularyManagerIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> {projectTitle}</span>
                <span style={{ display: 'block' }}>{id}</span>
            </span>}>
                <Chip
                    disabled={isReadOnly && notAvailable}
                    color="primary"
                    data-status={data.deprecated ?
                        "deprecated"
                        :
                        data.pendingDeletion || (!isReadOnly && notAvailable) ?
                            "deleted"
                            :
                            null}
                    style={
                        {
                            ...(data.deprecated) && { backgroundColor: '#FF6F00' },
                            ...(data.pendingDeletion || (!isReadOnly && notAvailable)) && { backgroundColor: '#DD2C00' }
                        }
                    }
                    className={classes.link}
                    avatar={<Avatar style={{ backgroundColor: 'inherit' }}><LinkIcon fontSize="small" /></Avatar>}
                    onClick={data.pendingDeletion || notAvailable ? null : this.handleClick}
                    onDelete={!isReadOnly && source ?
                        ((ev) => {
                            this.handleDeleteLink();
                            ev.preventDefault();
                            ev.stopPropagation();
                        })
                        :
                        null
                    }
                    label={data.literalForm ?
                        <span>
                            <span style={{
                                display: 'inline-block',
                                transform: 'translateY(2px)'
                            }}>
                                <LabelIcon fontSize="small" />
                            </span>
                            <span
                                data-test={dataTest || notAvailable ? 'op-link-disabled' : 'op-link'}
                                style={{
                                    display: 'inline-block',
                                    transform: 'translateY(-4px)',
                                    paddingTop: '5px',
                                    paddingLeft: '4px'
                                }}>
                                {label}
                            </span>
                        </span>
                        :
                        <span data-test={dataTest || notAvailable ? 'op-link-disabled' : 'op-link'}>
                            {label}
                        </span>
                    } />
            </Tooltip>
        );
    }
}

OtherProjectLink.defaultProps = {
    isReadOnly: false
};

OtherProjectLink.propTypes = {
    dataTest: PropTypes.string,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string,
    data: PropTypes.object,
    propertyGraph: PropTypes.string,
    history: PropTypes.object,
    source: PropTypes.string,
    sourceGraph: PropTypes.string,
    defaultLang: PropTypes.string,
    viewLang: PropTypes.string,
    isReadOnly: PropTypes.bool,
    property: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(withGS(OtherProjectLink, ["ALL"], null, {}, true)));